<ng-container>
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->

      <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        (click)="printPage()">
        Print
      </button>


      <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
        (click)="exportExcel('Office_Representativewise_Subscription_Report')" mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered" style="table-layout: auto; width: 100%;">
        <thead>

     <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 5" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - कार्यालय प्रतिनिधीनिनुसार- प्रतिनिधीनिहाय 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->


                         <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span>
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>


          <!-- <tr>
            <th *ngIf="totalth == 17" colspan="10" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 18" colspan="11" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 48" colspan="41" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th colspan="2">दिनांक -</th>
            <th colspan="2">{{ today | date:'dd-MM-yyyy' }}</th>
            <th colspan="3"></th>
          </tr> -->
          
          <!-- <tr>
            <th *ngIf="totalth == 18" colspan="11" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 48" colspan="41" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -</span> कार्यालय प्रतिनिधीनुसार
            </th>
            <th colspan="2">दिनांक -</th>
            <th colspan="2">{{ startDate | date:'dd-MM-yyyy' }}</th>
            <th colspan="1">पर्यंत</th>
            <th colspan="2">{{ endDate | date:'dd-MM-yyyy' }}</th>
          </tr> -->
        
          <tr>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">जिल्हा</th>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">तालुका</th>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;  word-wrap: break-word;">प्रतिनिधींचे नाव</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" colspan="4" style="border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; border-left: 2px solid black;">{{ data.name }}</th>
              <!-- <th *ngIf="data.isVisible" rowspan="2">रक्कम रुपये</th> -->
            </ng-container>
          </tr>
          <tr>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">वर्गणीदार संख्या</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <!-- <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->
            <!-- <th>रक्कम रुपये</th> -->
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
              <!-- <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->

            </ng-container>
          </tr>
        </thead>
        <tbody>
          <!-- <ng-container *ngFor="let item of finalData; let end=last;">
            <ng-container *ngIf="!end">
             
              <ng-container *ngFor="let data of item; let i=index; let end1=last">
                <tr  *ngIf="!end1">
                  <td colspan="3" *ngIf="i == 0" style="text-align: center;">
                    {{data.office_rep_name}}
                  </td>
                  <td colspan="5" *ngIf="i == 0" style="text-align: center;"></td>
                   <ng-container *ngFor="let data of subTypesName && i == 0">
              <th *ngIf="data.isVisible"></th>
              <th *ngIf="data.isVisible"></th>
              <th *ngIf="data.isVisible"></th>
              <th *ngIf="data.isVisible"></th>
            </ng-container>
                </tr>
                
                <tr *ngIf="!end1">
                  <td *ngIf="i == 0">{{ data['district_name'] }}</td>
                  <td *ngIf="i != 0"></td>
                  <td>{{ data['taluka'] }}</td>
                  <td>{{ data['rep_name'] }} - {{ data['rep_taluka'] }}</td>
                  <td>{{ data['sub'] }}</td>
                  <td>{{ data['एकूण'] }}</td>
                  <td>{{ data['नवीन'] }}</td>
                  <td>{{ data['नूतनीकरण'] }}</td>
                  <td>{{ data['नूतनीकरणबाकी'] }}</td>
                 
                  <ng-container *ngFor="let sub of subTypesName">
                    <ng-container *ngIf="sub.isVisible">
                      <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                      <td>{{ data[getKey(sub.name)+ '_नूतनीकरण']}}</td>
                      <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                      <td>{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                      
                    </ng-container>
                  </ng-container>
                </tr>
                <tr *ngIf="end1">
                  <td colspan="3" class="centerText">{{ data['district_name'] }} - {{ data['name'] }}</td>
                  <td>{{ data['sub'] }}</td>
                  <td>{{ data['एकूण'] }}</td>
                  <td>{{ data['नवीन'] }}</td>
                  <td>{{ data['नूतनीकरण'] }}</td>
                  <td>{{ data['नूतनीकरणबाकी'] }}</td>
              
                  <ng-container *ngFor="let sub of subTypesName">
                    <ng-container *ngIf="sub.isVisible">
                      <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                      <td>{{ data[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                      <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                      <td>{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                    
                    </ng-container>
                  </ng-container>
                </tr>
              </ng-container>
             
            </ng-container>
            <ng-container *ngIf="end">
              <tr class="smallHeading">
                <td colspan="3">{{ item['name'] }}</td>
                <td>{{ item['sub'] }}</td>
                <td>{{ item['एकूण'] }}</td>
                <td>{{ item['नवीन'] }}</td>
                <td>{{ item['नूतनीकरण'] }}</td>
                <td>{{ item['नूतनीकरणबाकी'] }}</td>
                
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td>{{ item[getKey(sub.name)+ '_नवीन'] }}</td>
                    <td>{{ item[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                    <td>{{ item[getKey(sub.name)+ '_एकूण'] }}</td>
                    <td>{{ item[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                    
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container> -->
       
       

<!-- <ng-container *ngFor="let item of finalData">

  <ng-container *ngIf="item?.name === 'एकूण'; else repBlock">
    <tr class="smallHeading">
      <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.name }}</td>
      <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item.sub }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['नूतनीकरण'] }}</td>
      <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black;">{{ item['नूतनीकरणबाकी'] }}</td>

      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item[getKey(sub.name) + '_नवीन'] }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ item[getKey(sub.name) + '_नूतनीकरण'] }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ (item[getKey(sub.name) + '_नवीन'] || 0) + (item[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ item[getKey(sub.name) + '_एकूण'] }}</td>
          <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>

  
  <ng-template #repBlock>
    <tr>
      <td colspan="3" style="text-align: center; font-weight: bold; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
        {{ item[0]?.office_rep_name }}
      </td>
      <td colspan="1"></td><td colspan="1"></td><td colspan="1"></td><td colspan="1"></td>
      <td colspan="1" style="border-right: 2px solid black;"></td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black;"></td>
          <td style="text-align: right;"></td>
          <td style="text-align: right;"></td>
          <td style="text-align: right;"></td>
          <td style="text-align: right; border-right: 2px solid black;"></td>
        </ng-container>
      </ng-container>
    </tr>

    <ng-container *ngFor="let district of getDistrictGroups(item)">
 
      <ng-container *ngFor="let block of district.rows; let i = index">
        <tr>
         
          <td style="font-weight: bold; border-left: 2px solid black;">
            <ng-container *ngIf="i === 0">{{ block['district_name'] }}</ng-container>
          </td>
          <td>{{ block['taluka'] }}</td>
          <td style="white-space: nowrap;">{{ block['rep_name'] }} - {{ block['rep_taluka'] }}</td>
          <td style="text-align: right; border-left: 2px solid black;">{{ block['sub'] }}</td>
          <td style="text-align: right;">{{ block['एकूण'] }}</td>
          <td style="text-align: right;">{{ block['नवीन'] }}</td>
          <td style="text-align: right;">{{ block['नूतनीकरण'] }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ block['नूतनीकरणबाकी'] }}</td>

          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td style="text-align: right; border-left: 2px solid black;">{{ block[getKey(sub.name) + '_नवीन'] }}</td>
              <td style="text-align: right;">{{ block[getKey(sub.name) + '_नूतनीकरण'] }}</td>
              <td style="text-align: right;">{{ (block[getKey(sub.name) + '_नवीन'] || 0) + (block[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td>
              <td style="text-align: right;">{{ block[getKey(sub.name) + '_एकूण'] }}</td>
              <td style="text-align: right; border-right: 2px solid black;">{{ block[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>

      
      <tr class="smallHeading">
        <td colspan="3" class="centerText" style="border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
          {{ district.total['district_name'] }} - {{ district.total['name'] }}
        </td>
        <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total.sub }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['नूतनीकरण'] }}</td>
        <td style="text-align: right; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['नूतनीकरणबाकी'] }}</td>

        <ng-container *ngFor="let sub of subTypesName">
          <ng-container *ngIf="sub.isVisible">
            <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ (district.total[getKey(sub.name) + '_नवीन'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
            </td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
            <td style="text-align: right; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-container>
  </ng-template>
</ng-container> -->



<ng-container *ngFor="let item of finalData">
  <!-- Grand Total Row -->
  <ng-container *ngIf="item?.isFinalTotal; else officeRepBlock">
    <tr class="smallHeading">
      <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.name }}</td>
      <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item.sub }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (item['नूतनीकरण'] || 0) + (item['नूतनीकरणबाकी'] || 0) }}</td>
      <!-- <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black;">{{ item['नूतनीकरणबाकी'] }}</td> -->

      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item[getKey(sub.name) + '_नवीन'] }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ (item[getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ (item[getKey(sub.name) + '_नवीन'] || 0) + (item[getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_एकूण'] }}</td>
          <!-- <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>

  <!-- Office Rep + District Grouping Block -->
  <ng-template #officeRepBlock>
    <!-- Office Rep Header -->
    <tr>
      <td colspan="3" class="text-center fw-bold" style="border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; font-weight: bold;">
        {{ item[0]?.office_rep_name }}
      </td>
      <td colspan="4" style="border-right: 2px solid black;"></td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td colspan="4" style="border-right: 2px solid black;"></td>
        </ng-container>
      </ng-container>
    </tr>

    <!-- Group by District -->
    <ng-container *ngFor="let district of getDistrictGroups(item)">
      <!-- Taluka Rows -->
      <ng-container *ngFor="let row of district.rows">
        <tr>
          <td style="border-left: 2px solid black;">
            <strong *ngIf="district.rows[0] === row">{{ row['rep_district'] }}</strong>
          </td>
          <td>{{ row['rep_taluka'] || '-' }}</td>
          <td>{{ row['rep_name'] ? row['rep_name'] : '-' }}{{ row['rep_taluka'] ? ' - ' + row['rep_taluka'] : '' }}</td>
          <td style="text-align: right; border-left: 2px solid black;">{{ row['sub'] }}</td>
          <td style="text-align: right;">{{ row['एकूण'] }}</td>
          <td style="text-align: right;">{{ row['नवीन'] }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ (row['नूतनीकरण'] || 0) + (row['नूतनीकरणबाकी'] || 0) }}</td>
          <!-- <td style="text-align: right; border-right: 2px solid black;">{{ row['नूतनीकरणबाकी'] }}</td> -->

          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td style="text-align: right; border-left: 2px solid black;">{{ row[getKey(sub.name) + '_नवीन'] }}</td>
              <td style="text-align: right;">{{ (row[getKey(sub.name) + '_नूतनीकरण'] || 0) +  (row[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
              <td style="text-align: right;">{{ (row[getKey(sub.name) + '_नवीन'] || 0) + (row[getKey(sub.name) + '_नूतनीकरण'] || 0) + (row[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
              <td style="text-align: right; border-right: 2px solid black;">{{ row[getKey(sub.name) + '_एकूण'] || 0 }}</td>
              <!-- <td style="text-align: right; border-right: 2px solid black;">{{ row[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>

      <!-- District Subtotal Row -->
      <tr class="smallHeading">
        <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; text-align: right;">
          {{ district.total['rep_district'] }} - एकूण
        </td>
        <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total.sub }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (district.total['नूतनीकरण'] || 0) + (district.total['नूतनीकरणबाकी'] || 0) }}</td>
        <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total['नूतनीकरणबाकी'] }}</td> -->

        <ng-container *ngFor="let sub of subTypesName">
          <ng-container *ngIf="sub.isVisible">
            <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total[getKey(sub.name) + '_नूतनीकरण'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total[getKey(sub.name) + '_नवीन'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरण'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
            <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
          </ng-container>
        </ng-container>
      </tr>
    </ng-container>

    <!-- Office Representative Total Row -->
    <tr class="smallHeading" *ngIf="item[item.length - 1]?.isOfficeRepTotal">
      <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; text-align: center;">
        {{ item[item.length - 1]['name'] }}
      </td>
      <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['sub'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['एकूण'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['नवीन'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (item[item.length - 1]['नूतनीकरण'] || 0) + (item[item.length - 1]['नूतनीकरणबाकी'] || 0) }}</td>
      <!-- <td style="text-align: right; border-top: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['नूतनीकरणबाकी'] }}</td> -->

      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_नवीन'] }}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ (item[item.length - 1][getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ (item[item.length - 1][getKey(sub.name) + '_नवीन'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_एकूण'] }}
          </td>
          <!-- <td style="text-align: right; border-top: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] }}
          </td> -->
        </ng-container>
      </ng-container>
    </tr>
  </ng-template>
</ng-container>





       
       
        </tbody>
      </table>
    </div>
  </div>

</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>